<template>
  <div class="custom-tabs">
    <div class="tabs is-boxed custom-tabs__tab-box">
      <ul class="custom-tabs__group">
        <li :class="{'is-active': isActiveTab(tab.components)}" v-for="tab in tabs">
          <router-link class="custom-tabs__link" :to="tab.url" :data-track="tab.track"><span class="custom-tabs__text">{{tab.name}}</span>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="custom-tabs__content-box">
      <keep-alive>
        <router-view v-bind="componentProps[$router.currentRoute.name]"></router-view>
      </keep-alive>
    </div>
  </div>
</template>

<script>
  import {misc} from '@/mixins'

  export default {
    name: 'CustomTabs',
    props: {
      tabs: {
        type: Array,
        required: true
      }
    },
    mixins: [misc],
    computed: {
      componentProps () {
        const data = {}
        this.tabs.forEach(tab => {
          tab.components.forEach(comp => {
            if ('props' in tab) {
              data[comp] = tab.props
            } else {
              data[comp] = {}
            }
          })
        })
        return data
      }
    },
    methods: {
      isActiveTab (components) {
        let isActive = false
        for (const component of components) {
          isActive = this.openActiveTabForURL(this.$router.currentRoute.name, component)
          if (isActive) {
            break
          }
        }
        return isActive
      }
    }
  }
</script>

<style scoped>
  .custom-tabs__tab-box {
    margin-bottom: -1px;
  }

  .custom-tabs__group {
    border: none;
  }

  .tabs.is-boxed a.custom-tabs__link {
    border: 1px solid rgba(88, 89, 91, 0.32);
    border-radius: 0;
    width: 193px;
    height: 45px;
    padding: 0;
    margin-right: 5px;
  }

  .tabs.is-boxed a.custom-tabs__link:hover {
    background-color: unset
  }

  .tabs.is-boxed li.is-active a.custom-tabs__link {
    background-color: #fafafa;
  }

  .custom-tabs__text {
    opacity: 0.5;
    font-size: 11px;
    color: #58595b;
  }

  .is-active .custom-tabs__text {
    opacity: 1;
    color: #30aae1;
  }

  .custom-tabs__content-box {
    border: 1px solid rgba(88, 89, 91, 0.32);
    background-color: #fafafa;
  }
</style>



// WEBPACK FOOTER //
// src/components/CustomTabs.vue